import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { DEFAULT_IMAGE } from "../../config/config";
import useDevice from "../../hooks/useDevice";
import { Skeleton } from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const EkhoolImage = ({ layout = 'fill', height, src,width, objectFit = 'cover', alt = '',errorDesign, ...props }) => {
  const { reducer } = useSelector((state) => state);
  const { appData } = reducer;
  const { isMobile, isTablet } = useDevice();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const imageOnError = (event) => {
    console.warn('Image failed to load:', src);
    setHasError(true);
    setIsLoading(false);
    event.currentTarget.src = DEFAULT_IMAGE;
    event.currentTarget.className = `${event.currentTarget.className} error`.trim();
  };

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const imageOnLoad = () => {
    setIsLoading(false);
  };
  const shouldShowFallback = hasError && errorDesign;

  const imageSrc = (!src || hasError) ? DEFAULT_IMAGE : src;

  return (
    <div style={{ position: 'relative', width: '100%', height: isMobile ? (height || '100%') : '100%' }}>      
      {!shouldShowFallback && (
        <img
          {...props}
          src={imageSrc}
          alt={alt}
          style={{
            height: isMobile ? (height || '100%') : (height || '100%'),
            objectFit: objectFit,
            width: (width || '100%'),
            top: 0,
            left: 0,
            opacity: isLoading ? 0.7 : 1,
            transition: 'opacity 0.3s ease',
            ...props.style
          }}
          onError={imageOnError}
          onLoad={imageOnLoad}
          loading="lazy" 
        />   
      )}
      {shouldShowFallback && (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#a3a3a3",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",            
            color: "#999",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >         
          <PlayCircleOutlineIcon className="default-circle-icons" sx={{color: '#fff',fontSize: {xs: 25, sm: 35}}}/>
        </div>
        )
      }
 
      {isLoading && (
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height="100%" 
          animation="wave" 
          sx={{ 
            position: 'absolute',
            top: 0,
            left: 0 
          }}
        />
      )}
     
    </div>
  );
};

export default EkhoolImage;